import { createWebHistory, createRouter } from 'vue-router';

import BGConteudo from '../screens/BGConteudo.vue';
import Op from '../screens/Op.vue'
export const routes = [    
    {path:'/revisorPisCofins', name:'protecao',component: BGConteudo},  
    {path:'/revisorPisCofins/:id/:isConsulta', name:'op',component: Op},  
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

export default router;